document.addEventListener("DOMContentLoaded", function() {
  // Move Shoppay Messaging
  let shoppay = document.querySelector('form.installment');
  let atc = document.querySelector('.product-add-to-cart-container');

  atc.appendChild(shoppay);
});

// HUK-123: Relocate the Yotpo AI review summary button up next to the top star rating.
// Yotpo's native "Reviews Summary on Star Rating Widget" toggle does not render on the
// app-block Star Rating Widget (verified on production), so we move the existing button.
// Moving the live node preserves its click handler; the summary drawer is portaled to
// <body>, so it still opens after the move. If the move ever fails, the button simply
// stays in its original bottom position (no regression).
(function () {
  var STAR_BLOCK_SELECTOR = '[id*="yotpo_product_reviews_ugc_star_rating"]';
  var SOURCE_BUTTON_SELECTOR = '.yotpo-main-widget-layout .yotpo-reviews-summary-button';
  var ROW_CLASS = 'acdc-review-row';
  var HOLDER_CLASS = 'acdc-ai-summary-top';
  // Yotpo has no field to rename the button, so we set the label ourselves after moving it.
  var BUTTON_TEXT = 'Review Highlights';
  var scheduled = false;

  // Wrap the star-rating app block and the relocated button in a single flex row so they
  // stay on one line (CSS keeps it nowrap) instead of wrapping as separate inline boxes.
  function getHolder(starBlock) {
    var row = starBlock.closest('.' + ROW_CLASS);
    if (!row) {
      row = document.querySelector('.' + ROW_CLASS);
      if (!row) {
        row = document.createElement('div');
        row.className = ROW_CLASS;
        starBlock.parentNode.insertBefore(row, starBlock);
      }
      // Move the star block in as the first item in the row.
      row.insertBefore(starBlock, row.firstChild);
    }
    var holder = row.querySelector('.' + HOLDER_CLASS);
    if (!holder) {
      holder = document.createElement('div');
      holder.className = HOLDER_CLASS;
      row.appendChild(holder);
    }
    return holder;
  }

  // Yotpo's button styling relies on CSS custom properties (--primary-color, etc.) defined
  // on the widget container. Our holder lives outside that container, so copy them across
  // to keep the button's native look in sync with Yotpo's configured theme.
  var YOTPO_VARS = ['--primary-color', '--yotpo-empty-white', '--primary-font-family', '--text-color'];

  function inheritYotpoVars(holder) {
    var src = document.querySelector('.yotpo-base-layout') || document.querySelector('.yotpo-main-widget-layout');
    if (!src) return;
    var cs = getComputedStyle(src);
    YOTPO_VARS.forEach(function (name) {
      var value = cs.getPropertyValue(name).trim();
      if (value) holder.style.setProperty(name, value);
    });
  }

  function placeSummaryButton() {
    scheduled = false;
    var starBlock = document.querySelector(STAR_BLOCK_SELECTOR);
    if (!starBlock) return;
    var holder = getHolder(starBlock);
    inheritYotpoVars(holder);
    // The not-yet-relocated button lives inside the main reviews widget. Once moved into
    // our holder it no longer matches this selector, so this is a no-op after placement.
    var button = document.querySelector(SOURCE_BUTTON_SELECTOR);
    if (!button) return;
    while (holder.firstChild) holder.removeChild(holder.firstChild);
    holder.appendChild(button);
    // Relabel the button (Yotpo offers no setting for this). Re-applied each placement, so
    // it survives Yotpo re-rendering a fresh button at the bottom.
    var label = button.querySelector('.yotpo-reviews-summary-button-text');
    if (label && label.textContent !== BUTTON_TEXT) label.textContent = BUTTON_TEXT;
  }

  // Yotpo renders (and can re-render) asynchronously; rAF-debounce so a busy DOM doesn't
  // thrash. Re-running is safe and idempotent.
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(placeSummaryButton);
  }

  function init() {
    // PDP-only guard: bail on pages without the product info column.
    if (!document.querySelector('.product-information')) return;
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();